import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateRefundDetailsAction as updateRefundDetails } from '../../../../../services/RefundService/slice';

export const RefundAmountField: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        
        // Allow empty string (for clearing the field)
        if (inputValue === '') {
            dispatch(updateRefundDetails({ amount: 0 }));
            return;
        }
        
        // Parse the value, but don't fallback to 0 if invalid
        const value = parseFloat(inputValue);
        if (!isNaN(value)) {
            dispatch(updateRefundDetails({ amount: value }));
        }
    };

    // Get the display value - show empty string if amount is 0, otherwise show the actual amount
    const getDisplayValue = () => {
        const amount = currentRefund?.refundDetail?.amount;
        if (amount === undefined || amount === null || amount === 0) {
            return '';
        }
        return amount.toString();
    };

    return (
        <TextField
            label="Refund Amount"
            type="number"
            value={getDisplayValue()}
            onChange={handleChange}
            size="small"
            required
            inputProps={{ min: 0, step: 0.01 }}
            InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
            sx={{ flex: 1 }}
        />
    );
};

export default RefundAmountField;
